
  const PMS_ENDPOINT = 'https://otc.overnighttablecovers.com/get-oms-colors-shopify';
  const pmsContainer = document.getElementById('pms-colors');
  const searchInput = document.getElementById('pms-search');
  const selectedInput = document.getElementById('selected-pms');

  let allColors = [];
  let selectedColors = [];

  if (pmsContainer) {
    fetch(PMS_ENDPOINT)
      .then(res => res.json())
      .then(data => {
        allColors = data;
        renderColors(data);
      })
      .catch(err => console.error('Error al cargar PMS:', err));
  }

  function renderColors(colors) {
    if (!pmsContainer) return;
    pmsContainer.innerHTML = '';
    colors.forEach(color => {
      const div = document.createElement('div');
      div.className = 'pms-color';
      div.style.backgroundColor = '#' + color.html_code;
      div.innerHTML = `<small>${color.name}</small>`;

      if (selectedColors.includes(color.name)) {
        div.classList.add('selected');
      }

      div.addEventListener('click', () => {
        if (selectedColors.includes(color.name)) {
          selectedColors = selectedColors.filter(c => c !== color.name);
          div.classList.remove('selected');
        } else {
          if (selectedColors.length >= 3) {
            alert('Solo puedes seleccionar hasta 3 colores PMS.');
            return;
          }
          selectedColors.push(color.name);
          div.classList.add('selected');
        }
        selectedInput.value = selectedColors.join(', ');
      });

      pmsContainer.appendChild(div);
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const query = this.value.toLowerCase();
      const filtered = allColors.filter(color => color.name && color.name.toLowerCase().includes(query));
      renderColors(filtered);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('form[action^="/cart/add"]');

    if (form && selectedInput) {
      form.addEventListener('submit', function(e) {
        if (!selectedInput.value.trim()) {
          e.preventDefault();
          e.stopPropagation(); 
          e.stopImmediatePropagation(); 
          alert('Por favor selecciona al menos un color PMS antes de continuar.');
          if (pmsContainer) pmsContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }

    const input = document.getElementById('excel-upload');
    const hiddenInput = document.getElementById('excel-file-id');
    const status = document.getElementById('upload-status');

    if (input) {
      input.addEventListener('change', async function () {
        const file = input.files[0];
        if (!file) return;

        if (!['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type)) {
          alert('Por favor sube un archivo Excel válido (.xls o .xlsx)');
          input.value = '';
          return;
        }

        const formData = new FormData();
        formData.append('excel_file', file);

        try {
          const response = await fetch('https://otc.overnighttablecovers.com/storage-roster-shopify', {
            method: 'POST',
            body: formData
          });

          if (!response.ok) throw new Error('Error al subir el archivo');

          const data = await response.json();
          hiddenInput.value = "https://otc.overnighttablecovers.com" + data.path;
          status.textContent = '✅ Archivo subido correctamente';
        } catch (error) {
          console.error(error);
          alert('Error al subir el archivo. Intenta de nuevo.');
        }
      });
    }
  });





